var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMailFilled = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.25 3.96A1.75 1.75 0 0 1 3 2.25h10a1.75 1.75 0 0 1 1.75 1.71L8 6.21 1.25 3.96z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.25 5.54V12c0 .966.784 1.75 1.75 1.75h10A1.75 1.75 0 0 0 14.75 12V5.54L8 7.79 1.25 5.54z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMailFilled);
export default ForwardRef;